export default function getAvatar(texto) {
    if (!texto) return "US"; // Fallback padrão caso venha vazio

    // 1. Remove números e espaços extras do final/início
    // Deixa apenas letras e espaços
    const apenasLetras = texto.replace(/[0-9]/g, "").trim();

    // 2. Divide a string em palavras usando o espaço como separador
    const palavras = apenasLetras.split(/\s+/).filter(Boolean);

    if (palavras.length === 0) return "US";

    let iniciais = "";

    if (palavras.length === 1) {
        // Se for apenas uma palavra, pega as duas primeiras letras
        iniciais = palavras[0].substring(0, 2);
    } else {
        // Se tiver duas ou mais palavras, pega a primeira letra da primeira
        // e a primeira letra da última palavra relevante
        const primeira = palavras[0];
        const ultima = palavras[palavras.length - 1];
        iniciais = primeira[0] + ultima[0];
    }

    // Retorna em letras maiúsculas
    return iniciais.toUpperCase();
}